const storeGroupIdParam = () => {
  const params = new URLSearchParams(window.location.search);
  const groupId = params.get("group_id");

  if (!groupId) return [];

  sessionStorage.setItem("groupId", groupId);

  return ["group_id"];
};

export default storeGroupIdParam;
